export const LayoutType = {
	MainWide: {
		header: 'pcMain', // 1280 (a, b)
		footer: 'pcMain',
		layoutClass: 'wide', // 1160
	},
	SimpleWide: {
		header: 'pcSimple',
		footer: 'pcSimple',
		layoutClass: 'wide', // 1160
	},
	SimpleBasic: {
		header: 'pcSimple', // 980
		footer: 'pcSimple',
		layoutClass: 'basic', // 980
	},
	Popup: {
		header: 'pcPopup',
		footer: 'pcPopup',
		layoutClass: 'popup',
	},
	CarDetail: {
		header: 'carDetail',
		footer: 'carDetail',
		layoutClass: 'car_detail',
	},
};

export default null;
